import { createFileRoute } from "@tanstack/react-router";
import EtimsChecklistPage from "@/features/public/pages/tools/etims-checklist";

export const Route = createFileRoute("/(public)/_public/tools/etims-checklist")({
  component: EtimsChecklistPage,
});
